import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/cpes/modelos`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(modelo) {
    let formData = new FormData(),
        headers = { headers: { 'Content-Type':'multipart/form-data' } }

    Object.keys(modelo).forEach(key => {
      if(modelo[key] == null) return
      formData.append(key, modelo[key])
    })

    return apiClient.post(`${modelo.id}`, formData, headers)    
  },

  eliminar(idModelo) {
    return apiClient.delete(`${idModelo}`)
  },

  guardar(modelo) {
    let formData = new FormData(),
        headers = { headers: { 'Content-Type':'multipart/form-data' } }

    Object.keys(modelo).forEach(key => {
      if(modelo[key] == null) return
      formData.append(key, modelo[key])
    })
    
    return apiClient.post('', formData, headers)
  },

  modeloJSON(idModelo) {
    return apiClient.get(`${idModelo}.json`)
  },

  modelosJSON(params) {
    params = params || {}
    return apiClient.get(`${API}/cpes/modelos.json`, { params: params })
  }
}
